import illustrationFallingWoman from '../../assets/svg/falling-person.svg'
import './index.css'

interface IProps {
  error?: string
}

export default function ErrorMessage({ error }: IProps) {
  return (
    <div className="error-wrapper">
      <div className="error-column">
        <div className="error-message-wrapper">
          <h1>Oops,</h1>
          <p className="error-message">{error || 'Something went wrong! Please try again later'}</p>
        </div>
      </div>
      <div className="error-column">
        <img src={illustrationFallingWoman} alt="Falling person" className="error-img" />
      </div>
    </div>
  )
}
